import m from "../../fonts/es2015/notosans-tc";
window.am4fonts_notosans_tc = m;


//////////////////
// WEBPACK FOOTER
// ./fonts/notosans-tc.js
// module id = null
// module chunks = 